import { HTTP_METHODS } from 'config';
import mobileRoApiConfig from 'api/mobile-ro';
import mobileApiConfig from 'api/mobile';
import agentsApiConfig from 'api/agents';
import {
  ENTRY_ACCESS_AGENT_KEY_CONFIRM,
  ENTRY_ACCESS_AGENT_KEY_STATUS,
  ENTRY_ACCESS_AGENT_KEYS_WITH_AGENT,
} from 'api/entry-access/endpoints';
import { CONFIRM_AGENT_KEY_COLLECTION } from 'api/mobile/endpoints';
import {
  FETCH_AGENT_KEY_STATUS,
  FETCH_KEYS_WITH_AGENT,
} from 'api/mobile-ro/endpoints';
import { isEntryAccessRoutesAgentsApiEnabled } from 'api/entry-access/isEntryAccessRoutesAgentsApiEnabled';

export const getKeysWithAgentKeyStatusList = async () => {
  if (await isEntryAccessRoutesAgentsApiEnabled()) {
    return agentsApiConfig({
      endpoint: ENTRY_ACCESS_AGENT_KEY_STATUS,
      method: HTTP_METHODS.GET,
    });
  }
  return mobileRoApiConfig({
    endpoint: FETCH_AGENT_KEY_STATUS,
    method: HTTP_METHODS.GET,
  });
};

export const getKeysWithAgent = async () => {
  if (await isEntryAccessRoutesAgentsApiEnabled()) {
    return agentsApiConfig({
      endpoint: ENTRY_ACCESS_AGENT_KEYS_WITH_AGENT,
      method: HTTP_METHODS.GET,
    });
  }
  return mobileRoApiConfig({
    endpoint: FETCH_KEYS_WITH_AGENT,
    method: HTTP_METHODS.GET,
  });
};

export const confirmAgentKeyCollection = async ({ houseId }) => {
  if (await isEntryAccessRoutesAgentsApiEnabled()) {
    return agentsApiConfig({
      endpoint: ENTRY_ACCESS_AGENT_KEY_CONFIRM,
      method: HTTP_METHODS.POST,
      payload: { houseId },
    });
  }
  return mobileApiConfig({
    endpoint: CONFIRM_AGENT_KEY_COLLECTION,
    method: HTTP_METHODS.POST,
    payload: { houseId },
  });
};
